
import React from 'react';

import GatsbyLink from './GatsbyLink';
import Logo from './Logo'
import Wrapper from './Wrapper'
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
} from 'reactstrap';

class NavWrapper extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.closeNavbar = this.closeNavbar.bind(this);
    this.state = {
      isOpen: false,
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  closeNavbar() {
    if (this.state.isOpen == true) {
      this.toggle();
    }
  }

  render() {
    return (
      <Wrapper className="fixed-top">
        <Navbar light expand="sm">
          <NavbarBrand href="/" style={{ boxShadow: "none", margin: "0", border: "none" }}>
            <Logo />
          </NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              <NavItem  onClick={this.closeNavbar}>
                <GatsbyLink to="/">Home</GatsbyLink>
              </NavItem>
              <NavItem  onClick={this.closeNavbar}>
                <GatsbyLink to="/about">About</GatsbyLink>
              </NavItem>
              <NavItem  onClick={this.closeNavbar}>
                <GatsbyLink to="/blog">Blog</GatsbyLink>
              </NavItem>
              <NavItem  onClick={this.closeNavbar}>
                <GatsbyLink to="/contact">Contact</GatsbyLink>
              </NavItem>
            </Nav>
          </Collapse >
        </Navbar >
      </Wrapper >
    );
  }
}

export default NavWrapper;



// WEBPACK FOOTER //
// ./src/components/Nav/index.js